import React, {Component} from 'react'
import Main from '../../components/Main/Main'

export default class MainPage extends Component {

  render() {
    return (
      <main>
        <Main />
      </main>
    )
  }
}